export default __webpack_public_path__ + "static/media/Paper.d5003ac8.png";